import Locale from '@dh-io-otb/shared/src/models/utilities/locale.model';

import { useStore } from '@dh-io-otb/shared/src/composables/store.composable';

import CiamService from '@dh-io-otb/shared/src/services/ciam.service';
import BootstrapService from '@dh-io-otb/shared/src/services/bootstrap.service';

import { useRoutingApplication } from '../composables/routing-application.composable';
export default class BootstrapApplicationService {
  static async bootstrap(locale: Locale): Promise<void> {
    const { dispatch, state, commit } = useStore();
    const { redirectToVMOS } = useRoutingApplication();

    window.otbs.build = {
      id: process.env.ID,
      version: process.env.VERSION,
      date: process.env.DATE,
    };

    this.setInitStyles();
    await BootstrapService.bootstrap(locale);

    const modelSelected = window.location.href.indexOf('modelSeries') > -1;
    if (!modelSelected && redirectToVMOS) redirectToVMOS();

    dispatch('getSpecificModel');

    if (state.otbcFlow.dealers && state.otbcFlow.dealers.length > 0 && state.otbcFlow.dealers[0] !== '')
      commit('fixedDealer', false);
    else if (state.otbcFlow.fixedDealer) {
      dispatch('getDealerData');
      dispatch('getTestDriveBookingVehicleSearchFixedDealer');
    }

    BootstrapApplicationService.fillProspectObject();
  }

  static setInitStyles(): void {
    // Due to header sticky position
    const html = document.querySelector('html');
    const body = document.querySelector('body');
    if (html) {
      html.style.position = 'static';
      html.style['scroll-behavior'] = 'smooth';
    }
    if (body) body.style['overscroll-behavior'] = 'none';
  }

  static fillProspectObject(): void {
    const { state } = useStore();

    if (state.configuration?.formConfig) {
      CiamService.handleLoggedInStatus(state.configuration.formConfig);
    }
  }
}
